var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "overlay-modal",
    {
      ref: "overlayModal",
      attrs: { width: "65%" },
      scopedSlots: _vm._u([
        {
          key: "header",
          fn: function() {
            return [
              _c("div", { staticClass: "d-flex justify-content-between" }, [
                _c("h4", [_vm._v("Dettaglio volo")])
              ])
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _vm._v(" "),
      [
        _c(
          "div",
          { staticClass: "modal-flight-detail" },
          [
            _c(
              "DefaultPanel",
              {
                staticClass: "flight-panel",
                attrs: {
                  title: "Volo selezionato",
                  "is-selected": _vm.selected
                },
                scopedSlots: _vm._u([
                  {
                    key: "top-right",
                    fn: function() {
                      return [
                        _c(
                          "div",
                          {
                            staticClass: "d-flex",
                            on: { click: _vm.onSelect }
                          },
                          [
                            _c(
                              "h3",
                              {
                                class:
                                  _vm.value.prezzoVenditaDelta > 0
                                    ? "more"
                                    : "minus"
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.value.prezzoVenditaDelta > 0
                                      ? "+" + _vm.value.prezzoVenditaDelta
                                      : _vm.value.prezzoVenditaDelta
                                  ) + " €"
                                )
                              ]
                            )
                          ]
                        )
                      ]
                    },
                    proxy: true
                  }
                ])
              },
              [
                _vm._v(" "),
                [
                  _c("FlightSection", {
                    attrs: { value: _vm.value, mode: "detail" }
                  })
                ]
              ],
              2
            )
          ],
          1
        )
      ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5aa6256f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5aa6256f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/front/components/widgets/common/modals/ModalFlightDetail.vue
// module id = null
// module chunks = 